import React from 'react';
import { CheckIcon } from '@tink/core/src/components/atoms/Icons/CheckIcon';
import { Sizes } from 'styled-components';
import { Container, TextContainer } from './CheckmarkText.styles';

type CheckmarkTextProps = {
  margin?: Sizes;
  children: React.ReactNode;
};

export const CheckmarkText = ({ children, margin }: CheckmarkTextProps) => {
  return (
    <Container margin={margin}>
      <CheckIcon />
      <TextContainer>{children}</TextContainer>
    </Container>
  );
};
